/**
 * <s-edge-drift> — Pinned page-edge texture that drifts upward slower than the page.
 *
 * The motion itself is a CSS scroll-driven animation (the `edge-drift` utility), so the
 * browser keeps it in sync with scrolling. This element only measures how far the
 * texture should travel and writes it to --edge-travel, re-measuring when the page
 * or viewport changes size. It never runs on scroll.
 *
 * Element dataset:
 *   data-speed — Share of scroll speed the texture moves at (default 0.4).
 */
class SEdgeDrift extends HTMLElement {
  #observer;
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.#observer = new ResizeObserver(() => this.#measure());
    this.#observer.observe(document.body);
    window.addEventListener('resize', () => this.#measure(), { passive: true, signal: this.#ac.signal });
    this.#measure();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#ac?.abort();
  }

  #measure() {
    const speed = Number.parseFloat(this.dataset.speed ?? '0.4') || 0;
    const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    this.style.setProperty('--edge-travel', `${Math.round(maxScroll * speed)}px`);
  }
}

if (!customElements.get('s-edge-drift')) customElements.define('s-edge-drift', SEdgeDrift);
